import { Check } from 'lucide-react';
import { Card } from 'shared/components/ui/Card';
import { Button } from 'shared/components/ui/Button';
import { useState } from 'react';
import { useToast } from 'shared/components/ui/Toast';
import { copyInviteLink } from 'shared/utils/invite';
import { ROUTES } from 'shared/constants/routes';

interface NextGameCardProps {
  title: string;
  location: string;
  spotsLabel: string;
  startsInLabel: string;
}

export function NextGameCard({ title, location, spotsLabel, startsInLabel }: NextGameCardProps) {
  const toast = useToast();
  const [confirmed, setConfirmed] = useState(false);

  function confirm() {
    setConfirmed(true);
    toast({ title: 'Presença confirmada', description: `${title} · o grupo foi avisado.` });
  }

  async function invite() {
    const copied = await copyInviteLink(ROUTES.MURAL);
    toast(
      copied
        ? { title: 'Link de convite copiado', description: 'Cole no WhatsApp para chamar alguém para a vaga.' }
        : { title: 'Convite pronto', description: 'Compartilhe o racha pelo mural da arena.', tone: 'info' }
    );
  }

  return (
    <Card>
      <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-wide text-ink-secondary">
        <span>Próximo jogo</span>
        <span>{startsInLabel}</span>
      </div>

      <h3 className="mt-2 font-heading text-lg font-semibold text-ink">{title}</h3>
      <p className="mt-1 text-sm text-ink-secondary">
        {location} · {spotsLabel}
      </p>

      <div className="mt-4 flex gap-3">
        <Button className="flex-1" onClick={confirm} disabled={confirmed}>
          {confirmed ? (
            <>
              <Check className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" />
              Confirmado
            </>
          ) : (
            'Confirmar'
          )}
        </Button>
        <Button variant="ghost" className="flex-1" onClick={invite}>
          Convidar
        </Button>
      </div>
    </Card>
  );
}
